import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./AdminDashboard.css";

// FIX: Function defined outside to prevent "use-before-define" error in Vercel
const getTodayFormatted = () => {
  const date = new Date();
  const dd = String(date.getDate()).padStart(2, '0');
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const yyyy = date.getFullYear();
  return `${dd}-${mm}-${yyyy}`;
};

const AdminDashboard = () => {
  const navigate = useNavigate();
  const contentRef = useRef(null);
  const [toast, setToast] = useState({ show: false, message: "" });
  const [activeSection, setActiveSection] = useState("today");
  const [appointments, setAppointments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [rescheduleData, setRescheduleData] = useState({ id: null, date: "", time: "" });

// Inside your AdminDashboard component:
// Check around line 64 and remove the extra one!
const [selectedViewDate, setSelectedViewDate] = useState(new Date().toISOString().split('T')[0]);

  useEffect(() => {
    fetchAppointments();
  }, []);

  const fetchAppointments = async () => {
    try {
      const response = await fetch('/api/db', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action: 'fetch-appointments' })
      });
      const result = await response.json();
      if (!result.error) setAppointments(result.data);
    } catch (err) {
      console.error("Fetch error", err);
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    sessionStorage.removeItem("adminAuth");
    navigate("/");
  };

  const todayDateStr = getTodayFormatted();

  // Filters
  const todaySchedule = appointments.filter((app) => 
    app.preferred_date && app.preferred_date.includes(todayDateStr)
  );

  const pendingRequests = appointments.filter(app => app.status === "pending");


  // 1. Updated Handle Accept (Approve)
  const handleAccept = async (appointment) => {
    try {
      const response = await fetch('/api/db', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          action: 'update-status', 
          data: { 
            id: appointment.id, 
            status: 'approved',
            // Passing data for the SMS trigger in backend
            name: appointment.users?.name,
            phone: appointment.users?.phone,
            date: appointment.preferred_date,
            time: appointment.preferred_time
          } 
        })
      });

      if (response.ok) {
        setAppointments(prev => prev.map(appt => appt.id === appointment.id ? { ...appt, status: "approved" } : appt));
        showToast(`Appointment approved. SMS sent to ${appointment.users?.name}`);
      }
    } catch (err) {
      console.error("Approval error", err);
    }
  };

  // 2. Updated Handle Reschedule
     const handleRescheduleSubmit = async (appointment) => {
  try {
    // 1. FORMAT THE DATE correctly to match todayDateStr (DD-MM-YYYY)
    // rescheduleData.date comes from <input type="date"> as "YYYY-MM-DD"
    const [year, month, day] = rescheduleData.date.split("-");
    const formattedDate = `${day}-${month}-${year}`; 

    const response = await fetch('/api/db', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ 
        action: 'reschedule', 
        data: { 
          id: appointment.id, 
          date: formattedDate, // Send the formatted version
          time: rescheduleData.time,
          name: appointment.users?.name,
          phone: appointment.users?.phone
        } 
      })
    });

    if (response.ok) {
      setAppointments(prev => 
        prev.map(appt => 
          appt.id === appointment.id 
            ? { 
                ...appt, 
                preferred_date: formattedDate, // Update with formatted date
                preferred_time: rescheduleData.time, 
                status: 'approved' 
              } 
            : appt
        )
      );

      setRescheduleData({ id: null, date: "", time: "" });
      showToast(`Rescheduled to ${formattedDate} and approved`);
    }
  } catch (err) {
    console.error("Reschedule error", err);
  }
};

const convertTo12Hour = (time24) => {
  if (!time24) return "";

  const [hours, minutes] = time24.split(":");
  let h = parseInt(hours);
  const ampm = h >= 12 ? "PM" : "AM";

  h = h % 12;
  h = h ? h : 12;

  return `${h}:${minutes} ${ampm}`;
};

const showToast = (message) => {
  setToast({ show: true, message });

  setTimeout(() => {
    setToast({ show: false, message: "" });
  }, 3000); // disappears in 3 sec
};



  return (
    <div className="admin-dashboard-container">
      <div className="admin-sidebar">
        <h2>Dr. Shivani</h2>
        <button className="logout-btn" onClick={handleLogout}>Logout</button>
        <ul>
          <li className={activeSection === "today" ? "active" : ""} onClick={() => setActiveSection("today")}>Today's Schedule</li>
          <li className={activeSection === "approve" ? "active" : ""} onClick={() => setActiveSection("approve")}>
            Approve Requests {pendingRequests.length > 0 && <span className="badge">{pendingRequests.length}</span>}
          </li>
          <li className={activeSection === "all" ? "active" : ""} onClick={() => setActiveSection("all")}>View Appointments</li>
        </ul>
      </div>

      <div className="admin-main">
        {loading ? <p>Loading...</p> : (
          <div ref={contentRef} className="content-area">
          
            {/* TODAY VIEW */}
            {activeSection === "today" && (
              <div className="view-section">
                <h3>Today's Schedule ({todayDateStr})</h3>
                {todaySchedule.length === 0 ? (
                  <p>No appointments today.</p>
                ) : (
                  <div className="table-container-responsive">
                    <table className="schedule-table">
                      <thead>
                        <tr>
                          <th>Time</th>
                          <th>Patient</th>
                          <th>Age</th>
                          <th>Phone</th>
                          <th>Problem</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {[...todaySchedule]
                          .sort((a, b) => a.preferred_time.localeCompare(b.preferred_time))
                          .map((app) => (
                            <tr key={app.id}>
                              <td className="nowrap">{convertTo12Hour(app.preferred_time)}</td>
                              <td className="bold-text">{app.users?.name}</td>
                              <td>{app.users?.age}</td>
                              <td>{app.users?.phone}</td>
                              <td className="problem-col">{app.problem || "N/A"}</td>
                              <td>
                                <span className={`status-badge ${app.status}`}>{app.status}</span>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}



            {/* APPROVE REQUESTS */}
            {activeSection === "approve" && (
              <div className="view-section">
                <h2>Pending Requests</h2>
                {pendingRequests.length === 0 ? <p>No pending requests.</p> : pendingRequests.map(req => (
                  <div key={req.id} className="request-card">
                    <div className="info">
                      <h4>{req.users?.name} (Age: {req.users?.age})</h4>
                      <p>Phone: {req.users?.phone}</p>
                      <p>
                      Requested: {req.preferred_date} at {convertTo12Hour(req.preferred_time)}
                      </p>
                      <p>Symptoms: {req.problem}</p>
                    </div>
                    <div className="card-actions">
                      <button className="btn-accept" onClick={() => handleAccept(req)}>Approve</button>
                      <button className="btn-reschedule" onClick={() => setRescheduleData({ id: req.id, date: "", time: "" })}>Reschedule</button>
                    </div>
                    {rescheduleData.id === req.id && (
                      <div className="reschedule-form-overlay">
                        <p>Date:</p>
                        <input 
                          type="date" 
                          onChange={e => setRescheduleData({...rescheduleData, date: e.target.value})} 
                        />
                        <p>Time:</p>
                        <input type="time" onChange={e => setRescheduleData({...rescheduleData, time: e.target.value})} />
                        <div className="reschedule-confirm-actions">
                           <button className="btn-accept" onClick={() => handleRescheduleSubmit(req)}>Confirm</button>
                           <button className="btn-reschedule" style={{background: 'red', color: 'white'}} onClick={() => setRescheduleData({id: null})}>Cancel</button>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}

            {/* VIEW APPOINTMENTS BY DATE */}
           {activeSection === "all" && (
            <div className="view-section">
              <h2>Find Appointments</h2>
              
              <div className="date-picker-container" style={{ marginBottom: '20px' }}>
                <label htmlFor="date-select" style={{ marginRight: '10px' }}>Select Date:</label>
                <input 
                  id="date-select"
                  type="date" 
                  value={selectedViewDate} 
                  onChange={(e) => setSelectedViewDate(e.target.value)} 
                />
              </div>

              {/* Convert YYYY-MM-DD to DD-MM-YYYY for display and filtering */}
              {(() => {
                const [y, m, d] = selectedViewDate.split('-');
                const formattedSearchDate = `${d}-${m}-${y}`;

                const filteredAndSorted = appointments
                  .filter(app => app.preferred_date === formattedSearchDate)
                  .sort((a, b) => a.preferred_time.localeCompare(b.preferred_time));
                
                return (
                  <>
                    <h3>Results for {formattedSearchDate}</h3>
                    {filteredAndSorted.length === 0 ? (
                      <p>No appointments found for this date.</p>
                    ) : (
                      <div className="table-container-responsive">
                        <table className="schedule-table">
                          <thead>
                            <tr>
                              <th>Time</th>
                              <th>Patient</th>
                              <th>Age</th>
                              <th>Phone</th>
                              <th>Problem</th>
                              <th>Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {filteredAndSorted.map((app) => (
                              <tr key={app.id}>
                                <td className="nowrap">{convertTo12Hour(app.preferred_time)}</td>
                                <td className="bold-text">{app.users?.name}</td>
                                <td>{app.users?.age}</td>
                                <td>{app.users?.phone}</td>
                                <td className="problem-col">{app.problem || "N/A"}</td>
                                <td>
                                  <span className={`status-badge ${app.status}`}>{app.status}</span>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </>
                );
              })()}
            </div>
          )}


          </div>
        )}
      </div>
        {toast.show && (
          <div className="toast-notification">
            {toast.message}
          </div>
        )}
    </div>
  );
};

export default AdminDashboard;